import Crumbs from "components/HGBreadcrumbs/Crumbs";
import { useBreadCrumbLabels } from "./helper";

const HGBreadcrumbs = ({ light = false }) => {
    const { crumbs } = useBreadCrumbLabels();
    const mobileMaxWidth = `${145 / crumbs.length}%`;

    return (
        <div className="mr-0 xl:mr-8">
            <nav className="flex items-center gap-1 pl-2">
                {crumbs?.length > 1 && crumbs.map(({ label, href }, index) => {
                    if (index === crumbs.length - 1) {
                        return (
                            <span
                                key={index}
                                className={`text-sm font-normal capitalize overflow-hidden text-ellipsis whitespace-nowrap ${light ? 'text-white' : 'text-foreground'}`}
                                style={{ maxWidth: mobileMaxWidth }}
                            >
                                {label}
                            </span>
                        );
                    }
                    return (
                        <>
                            <Crumbs
                                key={index}
                                href={href}
                                light={light}
                                label={label}
                                mobileMaxWidth={mobileMaxWidth}
                            />
                            <span key={`sep-${index}`} className={`text-sm ${light ? 'text-white' : 'text-muted-foreground'}`}>/</span>
                        </>
                    );
                })}
            </nav>
        </div>
    );
};

export default HGBreadcrumbs;
